import { render } from "./RankingView.vue?vue&type=template&id=38e9cfad&scoped=true"
import script from "./RankingView.vue?vue&type=script&lang=js"
export * from "./RankingView.vue?vue&type=script&lang=js"

import "./RankingView.vue?vue&type=style&index=0&id=38e9cfad&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e9cfad"]])

export default __exports__